export const Header = (function () {
	'use strict';

	let $menu, $menuButton, $subMenuParent, $subMenuItem, $body;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');

		trackHeaderHeight();
		events();
	}

	// The header is fixed and changes height (e.g. the message wraps on phones);
	// expose it as --header-height so content/hero can clear it
	function trackHeaderHeight() {
		const header = document.querySelector('.site-header');
		if (!header) return;

		const update = () => {
			document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
			setHeaderSide(header);
		};
		update();
		if ('ResizeObserver' in window) new ResizeObserver(update).observe(header);
		window.addEventListener('resize', update);
	}

	// The header grid gives both outer columns the width of the wider side (hamburger on the
	// left, CTA button on the right) so the message column sits in the true center.
	function setHeaderSide(header) {
		const container = header.querySelector('.site-header__container');
		if (!container) return;

		const box = container.getBoundingClientRect();
		const middle = box.left + box.width / 2;
		let side = 0;

		[...container.children].forEach((el) => {
			if (el.classList.contains('site-header__message') || !el.offsetWidth) return;
			const r = el.getBoundingClientRect();
			side = Math.max(side, r.left + r.width / 2 < middle ? r.right - box.left : box.right - r.left);
		});

		document.documentElement.style.setProperty('--header-side', Math.ceil(side) + 'px');
	}

	function events() {
		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}
		});
	}

	return {
		init: init,
	};
})();
